module.exports = __webpack_public_path__ + "assets/bb8f360912cf5c29571b853843b035a5.png";